import { Component } from '@mycolorway/tao';
import moment from 'moment';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-readable-datetime', {
  properties: {
    type: {
      type: String,
      default: 'date',
    },

    date: {
      type: String,
      observer: 'renderReadableDatetime',
    },

    timezone: String,

    highlightOutdated: {
      type: Boolean,
      default: false,
    },

    highlightTarget: String,

    highlightClass: {
      type: String,
      default: 'outdated',
    },

    format: {
      type: String,
      observer: 'renderReadableDatetime',
    },
  },

  connected() {
    this.renderReadableDatetime();
  },

  renderReadableDatetime() {
    if (this.date) {
      const dates = this.date.split(',').filter(v => !!v)
        .map(v => (this.timezone ? moment.tz(v, this.timezone) : moment(v)));
      const readableOptions = { defaultFormat: this.format };

      this.textContent = dates.map(m => (
        this.type === 'time'
          ? m.readableTime(readableOptions) : m.readableDate(readableOptions)
      )).join(' - ');

      this.toggleOutdatedStatus(this.checkOutdated(dates));
    } else {
      this.toggleOutdatedStatus(false);
    }
  },

  checkOutdated(dates) {
    if (!this.highlightOutdated) return false;

    const checkedDate = dates[dates.length - 1].startOf('day');
    const today = (
      this.timezone ? moment.tz(new Date(), this.timezone) : moment(new Date())
    ).startOf('day');
    return checkedDate.isBefore(today);
  },

  toggleOutdatedStatus(outdated) {
    if (this.highlightTarget) {
      const target = closest(this, this.highlightTarget);
      if (target) target.classList.toggle(this.highlightClass, outdated);
    } else {
      this.classList.toggle(this.highlightClass, outdated);
    }
  },
});
